import { render, staticRenderFns } from "./comp_RecetaDigitalProductItem.vue?vue&type=template&id=70b2c64a&scoped=true&"
import script from "./comp_RecetaDigitalProductItem.vue?vue&type=script&lang=js&"
export * from "./comp_RecetaDigitalProductItem.vue?vue&type=script&lang=js&"
import style0 from "./comp_RecetaDigitalProductItem.vue?vue&type=style&index=0&id=70b2c64a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2c64a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VIcon,VMenu,VSpacer})
